<template>
    <div v-if="msg" class="error-message-container">
        <div class="error-message">
            <div v-html="msg"></div>
            <div class="guide-error"></div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    name: 'TuiError',
    props: {
        msg: String,
    },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.guide-error {
    background-image: url(../assets-fca/Guide/guide_error.svg);
    width: 142px;
    height: 182px;
    left:32px;
    position:absolute;
    top:10px;
}

.error-message-container {
    width: 100%;
    height: 119px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 28px;
}

.error-message {
    height: 119px;
    width: 621px;
    border-radius: 8px;
    background-color: #FFFFFF;
    overflow: hidden;
    color: #B53D30;
    font-family: Rubik;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding-left: 168px;
    padding-right: 38px;
}
</style>